import { Links2 } from '@app/baseBtl/sales/orders.interface';

export enum RecoveryStatus {
    COMPLETED = 'completed',
    ONGOING = 'ongoing',
    UNFINISHED = 'unfinished',
    UNSTARTED = 'unstarted',
}

export enum RecoverySteps {
    START = 'start',
    HOMEPAGE = 'homepage',
    ESTIMATION = 'estimation',
    PAYMENT = 'payment',
}

export interface CritereRepriseParProduit {
    criteresRepriseProduit: CriteresRepriseProduit[];
    id: string;
    marque: string;
    nom: string;
    _links: Links2;
}

export interface CriteresRepriseProduit {
    id: string;
    libelle: string;
    reponses: ReponseCriteres[];
    options?: string[];
    selected?: string;
    descriptionSelected?: string[];
    optionSelected?: string;
}

export interface ReponseCriteres {
    description: string[];
    id: string;
    libelle: string;
}

export interface DevisRepriseMobileOut {
    criteresReprise: DevisRepriseMoobileOutCritereReprise[];
}

export interface DevisRepriseMoobileOutCritereReprise {
    id: string;
    question: string;
    reponse: { id: string; value: string };
}

export interface DevisRepriseMobileIn {
    id: string;
    livraison: DevisRepriseMobileInLivraison[];
    montantEstimeReprise: number;
    montantEstimeRepriseHT: number;
    tauxTVA: number;
}

export interface DevisRepriseMobileInLivraison {
    insurance?: boolean;
    modeLivraison: string;
    montantAssurance: number;
    montantLivraison: number;
}

export interface RecoveryStorage {
    iban?: string;
    product?: {
        bonus: number;
        dates: {
            start: string;
            end: string;
        };
        hasBonus: boolean;
        item: { name: string; url: string };
    };
    recovery_id: string;
    status?: string;
    step?: string;
    recovery?: {
        criterias?: {
            id: string;
            imei?: string;
            items: CriteresRepriseProduit[];
        };
        estimation?: {
            amount?: number;
            id?: string;
            shipping?: DevisRepriseMobileInLivraison[];
            items?: { id?: string; criteresReprise: DevisRepriseMoobileOutCritereReprise[] };
        };
        product?: {
            brand: string;
            name: string;
        };
    };
}
